import type { ReactNode } from 'react'
import { FlowSectionGate } from 'v2/pages/settings/flows/flow-section-gate'
import {
  canOpenFlowSection,
  flowDenialReason,
  type RouteMeta,
} from 'v2/shared/utils/role-based-visibility'
import type { IRoute } from 'v2/types'

// Telephony > Flow reuses the Agents pages under the `flow` permission (not the org's agents switch)
// and the sidebar flag.
// Flags read false until hodor answers, so the route stays open while they load and the page waits.
export const flowRoute = (
  meta: RouteMeta | undefined,
  title: string,
  path: string,
  page: ReactNode,
): IRoute => ({
  title,
  path,
  component: <FlowSectionGate>{page}</FlowSectionGate>,
  hidden: true,
  notAllowed: !canOpenFlowSection(meta),
  accessDenialReason: flowDenialReason(meta),
})
